import type { ElementType } from 'react';
import { css } from '@emotion/react';
import type { Theme } from '@mui/material';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { GTAMExpanded, GTAMExtended, GTAMStandard } from '@noah-labs/fe-feature-assets';
import { coreThemeProps, cssMixins } from '@noah-labs/fe-shared-ui-components';
import { baseThemeProps } from './baseTheme';
import { components } from './components';
import { palette } from './palette';
import { typography } from './typography';

export function theme(Link?: ElementType): Theme {
  const customTheme = deepmerge(coreThemeProps, {
    ...baseThemeProps,
    components: components(Link, baseThemeProps.borderRadius),
    palette,
    typography,
  });
  const baseTheme = createTheme(customTheme);
  return responsiveFontSizes(baseTheme);
}

export const globalStyles = css`
  ${cssMixins.global};
  ${GTAMStandard.italic400};
  ${GTAMStandard.normal200}
  ${GTAMStandard.normal400};
  ${GTAMStandard.normal500};
  ${GTAMStandard.normal700};
  ${GTAMExtended.normal500};
  ${GTAMExtended.normal900};
  ${GTAMExpanded.normal900};
`;
